// Dependencies
import Pagination from 'components/pagination';


class ArchivePost {
  /**
   * Constructor: Front Page Constructor.
   */
  constructor() {
    // Root
    this._root = document.querySelector('[layout="archive-post"]');

    // Dependencies
    this.Pagination = new Pagination();
  }
}

export default ArchivePost;


// WEBPACK FOOTER //
// ./src/js/templates/archive-post.js